export default __webpack_public_path__ + "static/media/navigation-category-icon.f4a9e86b.svg";